export default __webpack_public_path__ + "static/media/Menu_Pullover_Zip.400e5d19.svg";